module.exports = __webpack_public_path__ + "img/ic_contentitem_play-inactive.7b6e91d7.svg";